module.exports = __webpack_public_path__ + "static/work32-d21825825df7171ae2d85373e4a0ddc0.jpg";